/* The Przegląd tab's main column — KANON „Karty zadań", layout A (24 September 2026): the tasks,
 * then the session table, 28px apart (`canvas.css` `.cv .cv-main`). The cards and the table carry
 * their own frames; this sheet is the column, its wait and its two quiet lines. */

.tab {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: var(--space-0);
  overflow-y: auto;
  scrollbar-gutter: stable;
}

.column,
.loaded {
  display: flex;
  flex-direction: column;
  gap: var(--space-7);
  min-width: 0;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-10px);
  min-width: 0;
}

/* „Jesteś na bieżąco" — one line where the task section would stand. */
.upToDate {
  min-height: var(--h-detail-ghost);
}

/* `--text-2`, not the canon's `--text-3` (3.0:1): the contrast deviation `DetailTab.module.css` records. */
.upToDateHint {
  margin-inline-start: var(--space-2);
  font-size: var(--fs-caption);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.notice {
  margin: var(--space-0);
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  line-height: var(--lh-normal);
  color: var(--text-2);
}

/* A failed read: its line, and „Spróbuj ponownie" under it at its own width. */
.failure {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  align-items: flex-start;
}

.emptyCard {
  padding: var(--space-6) var(--space-4);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

/* ── the wait ─────────────────────────────────────────────────────────────────
 * The column's shape as the median answer draws it — a heading, one quick card, a heading, the
 * table's first rows. The bars appear only after the gate's grace; the box is there from the first
 * frame. */

.wait {
  display: flex;
  flex-direction: column;
  gap: var(--space-10px);
}

.skelHead {
  width: 180px;
  height: 16px;
}

.skelCard {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  height: var(--h-talia-card);
  margin-block-end: var(--space-4);
  padding: var(--space-4);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

.skelLine {
  width: 40%;
  height: 12px;
}

.skelFigure {
  width: 120px;
  height: 40px;
}

.skelLineShort {
  width: 24%;
  height: 12px;
}

.skelTable {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
}

.skelRow {
  height: 24px;
}
